import { productBrandStyles } from "@insite/content-library/Components/ProductBrand";
import { TYPOGRAPHY } from "@store/theme/design";
import { linkStyles } from "@store/theme/mixins";
import { css } from "styled-components";

Object.assign(productBrandStyles, {
    nameLink: {
        typographyProps: {
            size: TYPOGRAPHY.size.smallest,
            weight: TYPOGRAPHY.weight.bold,
            transform: "uppercase",
        },
        css: css`
            ${linkStyles("text", "primary", false)}
        `,
    },
});
